import React               from 'react'
import { useCalendar }     from './useCalendar'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CALENDAR_VIEWS }  from '@helpers/javascript/calendar_helper'
import Checkbox            from '@shared/checkbox/checkbox'
import TimeRange           from './timeRange'

// Collapsible "Paramètres" panel — same look & behaviour as the "Filtres"
// panel (hidden by default): hours range + display checkboxes.
const Settings = () => {
  const { state, setState, TOOLS, filter, setFilter } = useCalendar()

  const hasResourceRows = TOOLS.resources.some(res => res.resource || res.resourceCategory || res.resourceGroup)

  return (
    <div className="calendar-filters">
      <div className="calendar-filter-toggle" onClick={() => setState({...state, settingsOpen: !state.settingsOpen })}>
        {state.settingsOpen ? <FontAwesomeIcon icon='caret-down' /> : <FontAwesomeIcon icon='caret-right' />}
        {I18n.t("calendar.settings_section")}
      </div>

      <div className={`calendar-filter${state.settingsOpen ? ' filter-open' : ''}`}>
        <TimeRange />

        <Checkbox
          checked   = {filter.showWeekends}
          id        = "weekend-checkbox"
          onChange  = {()=>setFilter(prevFilter=>({...prevFilter, showWeekends: !filter.showWeekends} ))}
          label     = {I18n.t("calendar.weekends")}
          className = "mt-3 form-group"
        />

        <Checkbox
          checked   = {filter.autoRefresh}
          id        = "auto-refresh-checkbox"
          onChange  = {()=>setFilter(prevFilter=>({...prevFilter, autoRefresh: !filter.autoRefresh} ))}
          label     = {I18n.t("calendar.auto_refresh")}
          className = "form-group"
        />

        { filter.view.name === CALENDAR_VIEWS.agenda &&
          <Checkbox
            checked   = {filter.stackedAgenda}
            id        = "stacked-agenda-checkbox"
            onChange  = {()=>setFilter(prevFilter=>({...prevFilter, stackedAgenda: !filter.stackedAgenda} ))}
            label     = {I18n.t("calendar.stacked_agenda")}
            className = "form-group"
          />
        }

        { hasResourceRows &&
          <Checkbox
            checked   = {filter.showResources}
            id        = "show-resources-checkbox"
            onChange  = {()=>setFilter(prevFilter=>({...prevFilter, showResources: !filter.showResources} ))}
            label     = {I18n.t("calendar.show_resources")}
            className = "form-group"
          />
        }

        { hasResourceRows && filter.showResources &&
          <Checkbox
            checked   = {filter.resourcesOnly}
            id        = "resources-only-checkbox"
            onChange  = {()=>setFilter(prevFilter=>({...prevFilter, resourcesOnly: !filter.resourcesOnly }))}
            label     = {I18n.t("calendar.resources_only")}
            className = "form-group"
          />
        }

        { TOOLS.projects &&
          <Checkbox
            checked   = {filter.projectsOnly}
            id        = "projects-only-checkbox"
            onChange  = {()=>setFilter(prevFilter=>({...prevFilter, projectsOnly: !filter.projectsOnly }))}
            label     = {I18n.t("calendar.projects_only")}
            className = "form-group"
          />
        }
      </div>
    </div>
  )
}

export default Settings
